import Toaster from './toaster';
var toaster = new Toaster();
export default toaster;